import { getEnv } from '@ctct/ctct-helpers';

import { BaseApiClient } from '../BaseApiClient';

class PartnerSvcApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v1/partner`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public getSummary() {
    return this.baseApiClient.get<unknown>('/summary');
  }
}

export const partnerSvcApi = new PartnerSvcApi();
